var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonIconCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 15.4624V18.5024C1.5 18.7824 1.72 19.0024 2 19.0024H5.04C5.17 19.0024 5.3 18.9524 5.39 18.8524L16.31 7.94244L12.56 4.19244L1.65 15.1024C1.55 15.2024 1.5 15.3224 1.5 15.4624ZM19.21 5.04244C19.3027 4.94993 19.3762 4.84004 19.4264 4.71907C19.4766 4.59809 19.5024 4.46841 19.5024 4.33744C19.5024 4.20648 19.4766 4.07679 19.4264 3.95582C19.3762 3.83485 19.3027 3.72496 19.21 3.63244L16.87 1.29244C16.7775 1.19974 16.6676 1.12619 16.5466 1.07601C16.4257 1.02583 16.296 1 16.165 1C16.034 1 15.9043 1.02583 15.7834 1.07601C15.6624 1.12619 15.5525 1.19974 15.46 1.29244L13.63 3.12244L17.38 6.87244L19.21 5.04244Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconCreate);
export default __webpack_public_path__ + "static/media/buttonIconCreate.8577839f5b6269db6c2d31e5bf25a31a.svg";
export { ForwardRef as ReactComponent };